import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "9",
  fill: "none",
  viewBox: "0 0 21 9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFF8E8",
      d: "M0 9h21c-1.551 0-2.873-.7-3.978-1.549-.926-.71-1.782-1.596-2.535-2.374l-.395-.406L10.5 1 6.908 4.67l-.395.407c-.753.778-1.61 1.663-2.535 2.374C2.873 8.3 1.55 9 0 9"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFD121",
      d: "M9.782.303 6.19 3.958l-.41.42C4.13 6.074 2.29 8 0 8v1c1.551 0 2.873-.697 3.978-1.542.926-.708 1.782-1.59 2.535-2.364l.395-.405L10.5 1.034l3.592 3.655.395.405c.753.775 1.61 1.656 2.535 2.364C18.127 8.303 19.449 9 21 9V8c-2.29 0-4.13-1.926-5.78-3.621l-.41-.421L11.218.303a1.003 1.003 0 0 0-1.436 0"
    }, null, -1)
  ]))]))
}
export default { render: render }